export default __webpack_public_path__ + "static/media/profilemobile-gifthist-nodata.8a227d0c.svg";